var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1462 5.10417V29.8958M32.0837 17.5C32.0837 12.0313 32.0837 9.29687 30.691 7.38062C30.2413 6.7617 29.697 6.2174 29.078 5.76771C27.1618 4.375 24.426 4.375 18.9587 4.375H16.042C10.5732 4.375 7.83887 4.375 5.92262 5.76771C5.30381 6.21696 4.75951 6.76076 4.3097 7.37917C2.91699 9.29688 2.91699 12.0327 2.91699 17.5C2.91699 22.9673 2.91699 25.7031 4.3097 27.6194C4.7594 28.2383 5.30369 28.7826 5.92262 29.2323C7.83887 30.625 10.5747 30.625 16.042 30.625H18.9587C24.4274 30.625 27.1618 30.625 29.078 29.2323C29.697 28.7826 30.2413 28.2383 30.691 27.6194C32.0837 25.7031 32.0837 22.9673 32.0837 17.5Z",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.584 20.4167L12.7946 18.8753C12.0436 18.2263 11.6673 17.9026 11.6673 17.5001C11.6673 17.0976 12.0436 16.7738 12.7946 16.1249L14.584 14.5834",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.709 10.2084H25.5215M27.709 16.0417H25.5215",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavClose);
export default __webpack_public_path__ + "static/media/navClose.724eedb978835abf79c9192581664400.svg";
export { ForwardRef as ReactComponent };